import { render, staticRenderFns } from "./InvestigationEdit.vue?vue&type=template&id=e2517354"
import script from "./InvestigationEdit.vue?vue&type=script&lang=js"
export * from "./InvestigationEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports